module.exports = __webpack_public_path__ + "img/32.bcea4bc1.jpg";